import React, { Component } from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import AccountCircle from "@material-ui/icons/AccountCircle";
import People from "@material-ui/icons/People";
import Event from "@material-ui/icons/Event";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Avatar from "@material-ui/core/Avatar";
import ActionCreators from "../store/actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import logo from "../images/ets-logo.PNG";
import LinkElement from './LinkElement';

import {
  Container,
  LinksWrapper,
  AccountButtonContainer
} from './styles/MenuAppBarStyled'
import UserDialog from "../Components/UserDialog/UserDialog";

class MenuAppBar extends Component {
  state = {
    anchorEl: null
  };

  handleMenu = event => this.setState({ anchorEl: event.currentTarget });
  handleClose = () => this.setState({ anchorEl: null });

  handleUserDetailsOpen = () => {
    this.props.changeUserDialog(true);
    this.handleClose();
  };

  render() {
    const { anchorEl } = this.state;
    const { operator } = this.props;

    const open = Boolean(anchorEl);

    return (
      <Container>
        <AppBar color="default" position="static">
          <Toolbar>
            <Avatar
              style={{ backgroundColor: "white", marginRight: 5 }}
              alt="Remy Sharp"
              src={logo}
            />

            <Typography variant="h6"> ETS Polska </Typography>

            <LinksWrapper>
              <LinkElement
                style={{ textDecoration: "none" }}
                title={'Kalendarz'}
                to={"./"}
                iconComponent={<Event style={{ marginRight: "5px" }} />}
              />

              <LinkElement
                style={{ textDecoration: "none", marginLeft: 15 }}
                title={'Klienci'}
                to={"./clients"}
                iconComponent={<People style={{ marginRight: "5px" }} />}
              />
            </LinksWrapper>

            <AccountButtonContainer>
              <Button onClick={this.handleMenu} variant="outlined">
                <AccountCircle style={{ marginRight: "5px" }} />
                {operator}
              </Button>

              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right"
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right"
                }}
                open={open}
                onClose={this.handleClose}
              >
                <MenuItem onClick={this.handleUserDetailsOpen}>Konto użytkownika</MenuItem>
                <MenuItem onClick={this.props.logout}>Wyloguj</MenuItem>
              </Menu>
            </AccountButtonContainer>
          </Toolbar>
        </AppBar>
        <UserDialog />
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    token: state.authReducer.token,
    operator: state.authReducer.operator,
    isLoader: state.requestReducer.isLoader
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(ActionCreators, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuAppBar);
